import { DEFAULT_TENANT_TIMEZONE, resolveTenantTimezone } from "@/lib/scheduling/tenant-timezone"
import { atom } from "jotai"
import schedulingContextAtom from "./scheduling-context"

const MINUTE_MS = 60_000

/**
 * Tenant zone as state: follows the scheduling context, so anything derived
 * from it recomputes when the zone resolves or changes. Sao Paulo until then.
 */
export const tenantTimezoneAtom = atom((get) => {
  const zone = get(schedulingContextAtom)?.timezone
  return zone ? resolveTenantTimezone(zone) : DEFAULT_TENANT_TIMEZONE
})

const minuteCounterAtom = atom(0)

minuteCounterAtom.onMount = (set) => {
  const bump = () => set((count) => count + 1)
  let interval: number | undefined
  const timeout = window.setTimeout(() => {
    bump()
    interval = window.setInterval(bump, MINUTE_MS)
  }, MINUTE_MS - (Date.now() % MINUTE_MS))

  function onVisible() {
    if (document.visibilityState === "visible") bump()
  }

  document.addEventListener("visibilitychange", onVisible)
  bump()

  return () => {
    window.clearTimeout(timeout)
    if (interval !== undefined) window.clearInterval(interval)
    document.removeEventListener("visibilitychange", onVisible)
  }
}

/**
 * Shared minute clock: one timer for the whole app, aligned to the wall-clock
 * minute. Read it as the `now` argument and as a dependency.
 */
export const minuteNowAtom = atom((get) => {
  get(minuteCounterAtom)
  return new Date()
})
